import React, { Component } from 'react';
import { Header, Segment, Form, Button,Progress,Table,Image } from "semantic-ui-react"
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import { DASHBOARD_API_URL, INSPECTION_API_URL } from '../../../constants/api_routes';
import axios from 'axios';
import { getHeader } from '../../../data/user_api';
import InspectionContainer from '../../../containers/inspection_container';
import html2canvas from 'html2canvas';

const uuidv1 = require('uuid/v1');
export default class ClerkDistribution extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fromDate:undefined,
            toDate:undefined,
            clerkList:[],
            clerkCount:undefined,
            loading:false,
            hideZeroes:false,
            sorted:false

        };
    }

    

    handleFilterSelection = () => {
        this.setState({dateFiltered: true});
        if(this.state.fromDate && this.state.toDate){
            this.getInspectionByDate(INSPECTION_API_URL, this.state.fromDate, this.state.toDate);
        }
    };

    componentDidMount(){
        this.getClerkNumbers()
      }

      getClerkNumbers = async () =>{
        try {
            const res = await axios.get(`${DASHBOARD_API_URL}/clerk_load`, {headers: getHeader()});          
this.setState({clerkList:[...res.data]})
        } catch (error) {
            return ({
                success: false,
                statusMessage: "Something went wrong. Try again.",
                status:error.response.status
            });
        }
      }
 getInspectionByDate = async () => {
    this.setState({loading:true,clerkCount:undefined})
    let clerkCount = {}
            const res = await axios.get(`${INSPECTION_API_URL}/list?start_date=${this.state.fromDate}&end_date=${this.state.toDate}`, {headers: getHeader()});
            res.data.inspections.forEach(inspection => { 
                if(inspection.user){
                if (clerkCount[inspection.user.name]) { clerkCount[inspection.user.name]++; } else { clerkCount[inspection.user.name] = 1; }
            }})
            this.setState({clerkCount:clerkCount,loading:false})
     
    };

    copyImgToCanvas = async () =>{
        html2canvas(document.querySelector("#distroTable")).then(canvas => {this.setState({distroPic:canvas.toDataURL('image/png')}); const { ClipboardItem } = window;canvas.toBlob(blob => navigator.clipboard.write([new ClipboardItem({'image/png': blob})]))})
    }
    sortByPref = async () =>{
            let   newClerkList = [...this.state.clerkList];
            newClerkList = newClerkList.sort((a,b)=>{return  b.jobs_per_week - a.jobs_per_week})
            if(this.state.sorted) {newClerkList = newClerkList.reverse()}
            this.setState({clerkList:newClerkList,sorted:!this.state.sorted})
    }

    sortByName = async () =>{
        let   newClerkList = [...this.state.clerkList];
        newClerkList = newClerkList.sort((a,b)=>{return a.name.localeCompare(b.name)})
        if(this.state.sorted) {newClerkList = newClerkList.reverse()}
        this.setState({clerkList:newClerkList,sorted:!this.state.sorted})
    }
    sortByCurrJob = async () =>{
        let   newClerkList = [...this.state.clerkList];
        newClerkList = newClerkList.sort((a,b)=>{ return ( this.state.clerkCount[b.name]||0) - (this.state.clerkCount[a.name]||0)})
        if(this.state.sorted) {newClerkList = newClerkList.reverse()}
        this.setState({clerkList:newClerkList,sorted:!this.state.sorted})
    }

    sortByDistFromTgt = async () =>{
        let   newClerkList = [...this.state.clerkList];
        newClerkList = newClerkList.sort((a,b)=>{ return ( (this.state.clerkCount[b.name]||0)-b.jobs_per_week) - ((this.state.clerkCount[a.name]||0) - a.jobs_per_week)})
        if(this.state.sorted) {newClerkList = newClerkList.reverse()}
        this.setState({clerkList:newClerkList,sorted:!this.state.sorted})
    }

    sortByProgress = async () =>{
        let   newClerkList = [...this.state.clerkList];
        newClerkList = newClerkList.sort((a,b)=>{ return (Math.round(((this.state.clerkCount[a.name]||0)/(a.jobs_per_week || 1))*100)) - Math.round(((this.state.clerkCount[b.name]||0)/(b.jobs_per_week || 1))*100)
        })
        if(this.state.sorted) {newClerkList = newClerkList.reverse()}
        this.setState({clerkList:newClerkList,sorted:!this.state.sorted})
    }

    
    render() {


        return <Segment  className="pad-top">
            <Header align="center">Clerk Distribution</Header>
        <Segment  style={{margin:"auto",width:"80%"}}>
                                <div style={{textAlign:"center"}}>
                                <Header content="Select Date Range"/>
                                <Form><span><b>From: </b>
                                <DayPickerInput
                                        placeholder="From"
                                        dayPickerProps={{
                                            todayButton: 'Today',
                                            firstDayOfWeek : 1,
                                        }}
                                        format="DD-MM-YYYY"
                                        value={this.state.fromDate?this.state.fromDate:moment().format("DD-MM-YYYY")}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        onDayChange={day => {day ? this.setState({fromDate: day,toDate:moment(day).add(6,"days").format("DD-MM-YYYY")}): this.setState({fromDate:undefined})}}/></span>
                                        <span><b>To: </b>
                                        <DayPickerInput
                                            placeholder="To"
                                            format="DD-MM-YYYY"
                                            formatDate={formatDate}
                                            value={this.state.toDate}
                                            parseDate={parseDate}
                                            dayPickerProps={{
                                                disabledDays: {before: this.state.fromDate},
                                                todayButton: 'Today',
                                                firstDayOfWeek : 1,
                                            }}
                                            onDayChange={day => {day ?this.setState({toDate: day}): this.setState({toDate:undefined}) }}/></span></Form>
                                            <br/> <Button disabled={!this.state.fromDate || !this.state.toDate || this.state.loading} content="Calculate Distribution" primary
                                        onClick={() => this.getInspectionByDate()} loading={this.state.loading}/></div>
                                        {this.state.clerkCount && <div>
                                            <Button onClick={this.copyImgToCanvas}>Copy Snapshot to Clipboard</Button>
                                            <Button onClick={()=>{this.setState({hideZeroes:!this.state.hideZeroes})}}>Hide Zero Jobs Per Week</Button>
                                            <Image style={{ margin: "auto", maxWidth: "100%" }} className={"pad-top"} src={this.state.distroPic} />
                                            </div>}

                                </Segment>
                              {this.state.clerkCount && <Segment id="distroTable"style={{margin:"auto",width:"80%"}}> 
                                    <Table columns="8"celled striped structured>
                                        <Table.Header>
                                            <Table.Row>
                                            <Table.HeaderCell colSpan="2">
                                            <Button onClick={this.sortByName}>Clerk</Button>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="center">
                                                <Button onClick={this.sortByCurrJob}>Current Job Count</Button>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="center">
                                                <Button onClick={this.sortByPref}>Preferred Job Amount</Button>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="center">
                                            <Button onClick={this.sortByDistFromTgt}>Difference From Target</Button>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan="3">
                                                <Button onClick={this.sortByProgress}>Progress</Button>
                                            </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                    {this.state.clerkList.map((clerk)=>{
                                        if(this.state.hideZeroes && clerk.jobs_per_week == 0) {} else {
                                        return <Table.Row key={clerk.name}><Table.Cell  colSpan="2">{clerk.name}</Table.Cell>
                                        <Table.Cell style={{textAlign:"center"}}><Button compact basic >{this.state.clerkCount[clerk.name] || 0} Jobs</Button></Table.Cell>
                                        <Table.Cell style={{textAlign:"center"}}><Button compact basic >{clerk.jobs_per_week} Jobs</Button></Table.Cell>
                                        <Table.Cell style={{textAlign:"center"}}><Button compact basic  color={(this.state.clerkCount[clerk.name] || 0) - clerk.jobs_per_week >= 0 ? "green" : "red"}>{(this.state.clerkCount[clerk.name] || 0) - clerk.jobs_per_week} Jobs</Button></Table.Cell>
                                        <Table.Cell colSpan="3"><Progress progress percent={Math.round(((this.state.clerkCount[clerk.name]||0)/(clerk.jobs_per_week || 1))*100)}indicating ></Progress></Table.Cell></Table.Row>}})}
                                        </Table.Body></Table>
                                </Segment>}
      </Segment>
  }
}




// WEBPACK FOOTER //
// ./src/views/report/clerk_distribution/clerk_distribution.js